import React from 'react';
import { Box, Container, Typography, Link as MuiLink, IconButton } from '@mui/material';
import { LinkedIn, GitHub, Twitter } from '@mui/icons-material';
import profileConfig from '../constants/profileConfig';
import { FaLinkedin, FaResearchgate, FaEnvelope } from 'react-icons/fa';
import { FaGoogleScholar } from "react-icons/fa6";
import { SiGooglescholar } from "react-icons/si";


const Footer = () => {
  return (
    <Box sx={{ backgroundColor: 'background.paper', py: 3, borderTop: '1px solid #eee', mt: 6 }}>
      <Container maxWidth="lg" sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: { xs: 2, md: 0 } }}>
          &copy; {new Date().getFullYear()} {profileConfig.displayName || profileConfig.fullName || ''}. All rights reserved.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          {(profileConfig.socialLinks || []).map((link, index) => (
            <IconButton
              key={index}
              component={MuiLink}
              href={link.url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
            >
              {link.type === 'linkedin' && <FaLinkedin />}
              {link.type === 'researchgate' && <FaResearchgate />}
              {link.type === 'googleScholar' && <SiGooglescholar />}
              {link.type === 'email' && <FaEnvelope />}
            </IconButton>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 